import React from 'react';
import BusComponent from '../BusComponent';


class AutomaticDownload extends BusComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {};

        this.bindGluBusEvents({
        });
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    render() {
        if (this.state.downloadLink) {
            return <iframe src={this.state.downloadLink} width="1px" height="1px" frameBorder="0" />;
        }
        return null;
    }
}

export default AutomaticDownload;
